<template>
  <div class="MoreInfo">

    <h3>
      Vad är MIK?
    </h3>
    <p>
      MIK står för medie- och informationskunnighet: att kunna hantera, värdera och analysera det informationsflöde som förekommer via olika medietyper. Det handlar om allt ifrån digital källkritik och reklamkunnighet till filmanalys och datorspel. MIK handlar om alla människors rätt till information och kunskap: kort och gott en demokratifråga.
    </p>
    <p>
      Begreppet MIK är myntat av <a href="https://www.unesco.se/kommunikation/medieutveckling-och-kapacitetsbyggande/medie-och-informationskunnighet/" target="_blank">UNESCO</a> och spelar en betydande roll i det nationella projektet <a href="https://digitaltforst.blogg.kb.se/" target="_blank">Digitalt Först</a>. 2018 upprättade regeringen en <a href="https://www.regeringen.se/pressmeddelanden/2018/08/nationell-satsning-pa-medie--och-informationskunnighet-ska-oka-motstandskraften-mot-desinformation-och-nathat/" target="_blank">nationell satsning på medie- och informationskunnighet</a> för att öka motståndskraften mot desinformation och näthat.

    </p>

    <h3>
      Vad är ett jam?
    </h3>

    <p>
      Under ett jam samlas människor från olika bakgrunder för att skapa tillsammans. MIK-jam pågår normalt under en heldag, och fokus är på att ha roligt, lära sig, och inspireras av varandra.
    </p>

    <p>
      Deltagarna matchas i grupper om 3-4 personer, beroende på målgrupp och deltagare kan grupperna vara en blandning av bibliotekspersonal, pedagoger, journalister och studenter. Deltagarna får allt som behövs för att tillsammans kunna vara kreativa och skapa, designa och presentera en lösning i slutet av eventet. Inga tidigare förkunskaper krävs. Det är blandningen av personer med olika kompetens som gör ett jam fantastiskt!
    </p>

    <p>
      Varje grupp kommer att arbeta med ett av flera teman. Samtliga <a href="#teman">teman presenteras längre ner på sidan</a> tillsammans med exempel på resultat som skulle kunna uppstå under ett MIK-jam!
    </p>

    <h3>Vad händer sen?</h3>

    <p>
      Förhoppningen är att deltagarna får mersmak under ett MIK-jam och vill arbeta vidare med sina idéer efter eventet! Det är dock helt frivilligt och inget krav.
    </p>

    <h4>Vem äger resultatet?</h4>
    <p>
      Det är deltagarna i respektive arbetsgrupp som gemensamt äger det de skapar under MIK-jam. Gruppen kan välja att bygga vidare på resultatet själva, eller släppa det under öppen licens för andra att utveckla vidare.
    </p>

  </div>
</template>

<script>

//import { store } from '@/store';
//import Component from '@/components/Component'

export default {
  name: 'MoreInfo',
  /*components: {
    Component
  },*/
  data () {
    return {
    }
  },
  props: {
  },
  computed: {
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style scoped>

.MoreInfo{
}

</style>



// WEBPACK FOOTER //
// src/components/MoreInfo.vue